/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SuggestMappingsRequestBuilderNavigationMetadata, SuggestMappingsRequestBuilderRequestsMetadata, type SuggestMappingsRequestBuilder } from './suggestMappings/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/data-imports
 */
export interface DataImportsRequestBuilder extends BaseRequestBuilder<DataImportsRequestBuilder> {
    /**
     * The suggestMappings property
     */
    get suggestMappings(): SuggestMappingsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DataImportsRequestBuilderUriTemplate = "{+baseurl}/api/data-imports";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DataImportsRequestBuilderNavigationMetadata: Record<Exclude<keyof DataImportsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    suggestMappings: {
        requestsMetadata: SuggestMappingsRequestBuilderRequestsMetadata,
        navigationMetadata: SuggestMappingsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
